export default "__VITE_IMAGE_ASSET__8d2e507b__";